import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
    PlatformTenantRolesTabs,
    type PlatformTenantRolesTab,
} from '../../pages/platform/tenants/roles/PlatformTenantRolesTabs';

// Pestaña Roles del drill-down: el tenantId sale del path; `?tab=matrix` abre la matriz de permisos.
export const Route = createFileRoute('/_authenticated/_layout/platform/tenants/$tenantId/roles')({
    validateSearch: (search: Record<string, unknown>): { tab?: PlatformTenantRolesTab } =>
        search.tab === 'matrix' ? { tab: 'matrix' } : {},
    component: TenantRoles,
});

function TenantRoles() {
    const { tenantId } = Route.useParams();
    const { tab } = Route.useSearch();
    const navigate = useNavigate();

    return (
        <PlatformTenantRolesTabs
            tenantId={tenantId}
            tab={tab}
            onTabChange={(next) => {
                void navigate({
                    to: '/platform/tenants/$tenantId/roles',
                    params: { tenantId },
                    search: next === 'matrix' ? { tab: 'matrix' } : {},
                });
            }}
        />
    );
}
